import { ReactComponent as TrashIcon } from "assets/delete.svg";
import * as S from './styles'

type PolicemanRowProps = {
  name: string
  isRegistered: boolean
  onTrashClick: (name: string, isRegistered: boolean) => void
}

export function PolicemanRow({ isRegistered, name, onTrashClick }: PolicemanRowProps) {
  const badgeClassnames = `badge ${isRegistered ? 'registered' : 'detached'}`

  return (
    <S.Wrapper>
      <p className="name">{name}</p>

      <div className="badge-container">
        <p className={badgeClassnames}>{isRegistered ? 'Registrado' : 'Avulso'}</p>
        <TrashIcon className="trash" onClick={() => onTrashClick(name, isRegistered)} />
      </div>
    </S.Wrapper>
  )
}